import React from 'react';
import VideoSection from './VideoSection';
import LoginForm from './LoginForm';
import Footer from './Footer';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  return (
    <div className="login-page">
      <VideoSection />
      <LoginForm />
      
      {/* Footer */}
      {/* <Footer /> */}
    </div>
  );
};

export default LoginPage;
